import React from 'react';
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { Helmet } from 'react-helmet-async';


// 🔰 Default site-wide SEO tags (editable)
const AppHelmet = () => (
  <>
    <Helmet>
      <title>Masho Perfumes | Love To The Soul | Long Lasting Fragrance</title>
      <meta name="description" content="Buy perfumes online in India at Masho Perfumes. Premium, long-lasting fragrances for men and women. Express shipping. Inspired by the romance of Laila & Majnu." />
      <meta name="keywords" content="perfumes online, buy perfume India, long lasting perfume, men’s perfume, women’s fragrance, oud perfume, Masho Perfumes" />
      <link rel="canonical" href="https://mashoperfumes.com/" />

      {/* Open Graph Meta */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mashoperfumes.com/" />
      <meta property="og:title" content="Masho Perfumes | Premium Perfumes Online" />
      <meta property="og:description" content="Shop long-lasting perfumes for men and women. Elegant fragrances crafted with passion. Order online from Masho Perfumes." />
      <meta property="og:image" content="https://mashoperfumes.com/assets/brand-preview.png" />

      {/* Twitter Meta */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content="https://mashoperfumes.com/" />
      <meta name="twitter:title" content="Masho Perfumes | Online Perfume Store India" />
      <meta name="twitter:description" content="Buy fragrances crafted with love and long-lasting impressions. Masho offers premium perfumes for every mood." />
      <meta name="twitter:image" content="https://mashoperfumes.com/assets/brand-preview.png" />
    </Helmet>
  </>
);


const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Auth0Provider
          domain="dev-d1aq0xw72d714fi0.us.auth0.com"
          clientId="m1SH9jfmUfiUoLrvtrb9M7YdVQ5Tsx1c"
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: "https://masho-api/",
            scope: "openid profile email read:current_user update:current_user_metadata create:current_user_metadata delete:current_user_metadata",
          }}
          cacheLocation="localstorage"
          useRefreshTokens={false}
          skipRedirectCallback={window.location.pathname === '/callback'}
        >
          <AppHelmet />
          <App />
        </Auth0Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
